<template>
    <div>
        <a href="#" class="open-modal btn btn-primary rounded-full" @click.prevent="openModal">
            <i class="fa fa-plus"></i>
        </a>

        <Modal v-if="showModal" modal-title="Add Service" @close="closeModal(true)">
            <template v-slot:body>
                <ServiceForm ref="form" />
            </template>
            <template v-slot:footer>
                <my-button :loading="submitting" class="btn btn-primary float-right" @click="submitForm">
                    <i class="fa fa-save"></i> Add Service
                </my-button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from '../Modal';
import ServiceForm from './ServiceForm';

export default {
    components: { Modal, ServiceForm },

    data() {
        return {
            showModal: false,
            submitting: false
        };
    },

    methods: {
        openModal() {
            this.showModal = true;
        },

        closeModal(confirmNeeded = false) {
            if (!confirmNeeded) {
                this.showModal = false;
                return;
            }

            if (confirm('You will loose all the data you have entered so far, are you sure?')) {
                this.showModal = false;
            }
        },

        submitForm() {
            this.submitting = true;

            this.$refs.form
                .submit()
                .then(() => {
                    this.$emit('added');
                    this.closeModal();
                    flash.success();
                })
                .catch(() => {
                    flash.error({ message: 'It seems like you have submitted invalid data.' });
                })
                .then(() => {
                    this.submitting = false;
                });
        }
    }
};
</script>
